// extracted by mini-css-extract-plugin
export default {"container":"KF-z","header":"LF-z","details":"MF-z","link":"NF-z"};